export const marbleConfig = {
  seed: 40173,
  fps: 60,
  durationSeconds: 12,
  physicsHz: 120,
  warmupSeconds: 4,
  count: 48,
  spawnInterval: 0.32,
  ballRadius: 0.18,
  gravity: -9.81,
  funnel: {
    innerRadius: 0.52,
    outerRadius: 2.25,
    bottomY: 3.1,
    slope: 0.56,
    wallHeight: 0.45,
    segments: 96,
    rings: 12,
  },
  rail: {
    startX: -1.0,
    endX: 3.25,
    floorY: 2.55,
    slope: 0.4,
    width: 0.72,
    catchWidth: 3.4,
    wallHeight: 0.54,
    thickness: 0.12,
    segments: 40,
    curveAmplitude: 0.5,
  },
  friction: 0.28,
  restitution: 0.08,
  injectionSpeed: 3.15,
  colors: ["#fa6f5d", "#f3c53d", "#22c4be", "#a38ae8"],
} as const;

export const railZ = (x: number) =>
  marbleConfig.rail.curveAmplitude *
  Math.sin(((x - marbleConfig.rail.startX) / (marbleConfig.rail.endX - marbleConfig.rail.startX)) * Math.PI * 2);

export const railY = (x: number) =>
  marbleConfig.rail.floorY -
  marbleConfig.rail.slope * (x - marbleConfig.rail.startX);

export const railWidth = (x: number) => {
  const t = Math.max(0, Math.min(1,
    (x - marbleConfig.rail.startX) / 2.2));
  return marbleConfig.rail.catchWidth * (1 - t) +
    marbleConfig.rail.width * t;
};

